module.exports = __webpack_public_path__ + "static/media/cds-home.a29e8f93.jpg";